import { useState } from 'react'
import type { step } from '../../../../utils/recipeUtils'
import './RecipeStep.scss'

interface RecipeStepProps {
  index: number
  step: step
  setStep: (index: number, newStep: step) => void
}

function RecipeStep({ index, step, setStep }: RecipeStepProps) {
  const [stepNum, setStepNum] = useState<number>(step.step_number)
  const [stepText, setStepText] = useState<string>(step.step)

  const handleStepNumChange = (newStepNum: number) => {
    setStepNum(newStepNum)
    handleStepChange(newStepNum, stepText)
  }
  const handleStepTextChange = (newStepText: string) => {
    setStepText(newStepText)
    handleStepChange(stepNum, newStepText)
  }

  const checkStepModified = (newStepNum: number, newStepText: string) => {
    return newStepNum !== step.step_number || newStepText !== step.step
  }

  const handleStepChange = (newStepNum: number, newStepText: string) => {
    if (checkStepModified(newStepNum, newStepText)) {
      const newStep: step = {
        ...step,
        step_number: newStepNum,
        step: newStepText,
        modified: true,
      }
      setStep(index, newStep)
    }
  }

  const handleDelete = () => {
    const newStep: step = { ...step, deleted: true }
    setStep(index, newStep)
  }

  return (
    <div className="recipe-list-item">
      <input
        type="number"
        className="recipe-step-num"
        defaultValue={stepNum}
        onChange={e => handleStepNumChange(Number(e.target.value))}
      />
      <input
        type="text"
        className="recipe-step-text"
        defaultValue={stepText}
        onChange={e => handleStepTextChange(e.target.value)}
      />
      <button className="recipe-step-delete-button" onClick={handleDelete}>
        ×
      </button>
    </div>
  )
}
export default RecipeStep
